import React, { useMemo } from 'react'
import { Box, Typography, Divider, Paper, Grid,  Button, TextField } from '@mui/material';
import { useSnackbar } from 'notistack';
import { useForm, Controller } from "react-hook-form";
import { submitFeedback } from 'services/feedback';

const Feedback = () => {
  const defaultFormFields = useMemo(() => ({
    feedback: '',
  }),[]);
  const { enqueueSnackbar } = useSnackbar();
  const { handleSubmit, control, formState: { errors }, reset } = useForm({
    mode: 'onTouched',
    defaultValues: {...defaultFormFields}
  });

  const onSubmit = (data) => {
    submitFeedback({...data, provider: 'vendor'}).then(({response, error}) => {
        if(response){
          enqueueSnackbar(response?.message || 'We have received your query' , {variant: 'success'});
          reset({...defaultFormFields});
        } else {
          enqueueSnackbar((response?.message || error), {variant: 'error'});
        }
      });
  };

  return (
    <Paper sx={{ minWidth: 275, py: 2, px: 3, minHeight: "calc(100vh - 100px )" }}>
      <Typography component="h2" variant="h6" color="secondary" gutterBottom sx={{mb: 1}}>
        Feedback
      </Typography>
      <Divider />
      <Box  component="form" noValidate  sx={{ mt: 2 }} onSubmit={handleSubmit(onSubmit)} >
        <Grid container columnSpacing={4} rowSpacing={2} justifyContent="space-around">
          <Grid item xs={10} sm={10} md={6} xl={5} lg={5} sx={{alignItems: 'center',display: 'flex'}}>
            <Paper sx={{boxShadow: "rgb(58, 53, 65, 0.1) 0px 2px 10px 0px", backgroundColor: '#f7f7f7'}}>
              <Grid item xs={12} sm={12} md={12} xl={12} lg={12} sx={{  }}>
                <img
                  src='/assets/images/feedback.png'
                  alt="Refer and Earn"
                  loading="lazy"
                  style={{width: '100%'}}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={12} sx={{m: 2}}>
                <Controller
                  control={control}
                  name="feedback"
                  id="feedback"
                  rules={{ required: "Enter feedback" }}
                  render={({field}) => (
                    <TextField
                      {...field}
                      margin="normal"
                      placeholder="Feedback"
                      multiline
                      required
                      error={!!errors?.feedback}
                      size="small"
                      fullWidth
                      rows={10}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={12} sx={{m: 2}} textAlign="center">
                  <Button variant='contained' type='submit' sx={{textTransform: 'none'}}>Submit Query</Button>
              </Grid>
            </Paper>
          </Grid>
        </Grid>
      </Box>
    </Paper>
  );
}
 
export default React.memo(Feedback);
